import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import Button from 'components/button/button'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { 
	saveItem, 
	openModal,
	updateOrganisationOrder
} from 'state/actions'

import { 
	DragDropContext, 
	Droppable, 
	Draggable
} from 'react-beautiful-dnd'

import { 
	getCurrentUser, 
	getCurrentAccount 
} from 'state/selectors'

import ProfilePicture from 'components/profile/profile-picture'
import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import { 
	doSort,
	isMobile
} from 'utils'

class ModalOrganisations extends Component {
	portal = null
	accountsArray = []

	UNSAFE_componentWillMount() {
		if(!isMobile()){
			this.portal = document.createElement('div')
			this.portal.classList.add('accounts-list','users-list','list')

			document.body.appendChild(this.portal)
		}else{
			this.portal = null
		}
	}
	
	setLoading = isLoading => {
		this.setState({
			isLoading: isLoading,
		})
	}

	swapAccount = slug => {
		this.props.history.push('/' + slug)
	}

	doAccountAction = (action, account) => {
		const {
			openModal,
			closeCallback
		} = this.props

		closeCallback()

		setTimeout(_ => {
			if(action == 'leave'){
				account.leaveOnly = true
				return openModal('delete', 'organisation', account)
			}

			return openModal('close', 'account', account)
		},300)
	}

	addNewAccount = _ => {
		this.props.openModal('register', 'register', {
			isSecondaryAccount: true,
			canGoBack: true
		})
	}

	onDragStart = _ => {

	}

	onDragEnd = result => {
		const {
			updateOrganisationOrder,
			userData
		} = this.props

		if(!result.destination){
			return
		}

		const draggableId = parseInt(result.draggableId.replace('org-',''))
		const newIndex = result.destination.index

		if (result.destination) {
			let updatedOrganisations = []

			const allOrganisations = this.accountsArray.map(account => {
				return account.id
			})

			allOrganisations.splice(allOrganisations.indexOf(draggableId), 1)
			allOrganisations.splice(newIndex, 0, draggableId)

			allOrganisations.forEach(id => {
				updatedOrganisations.push(id)
			})

			updateOrganisationOrder(updatedOrganisations, userData)
		}
	}

	getAccountsArray = () => {
		const {
			userData,
			allAccounts
		} = this.props

		let accountsArray = userData.accounts.map(accountId => {
			const accountObject = allAccounts[accountId]

			if(!accountObject || !accountObject.users){
				return 
			}

			return accountObject
		}).filter(Boolean)

		accountsArray = doSort(accountsArray, 'alpha', 'name')

		if(userData.organisation_order){
			accountsArray = accountsArray.sort((a, b) => {
				const aOrder = userData.organisation_order.indexOf(a.id)
				const bOrder = userData.organisation_order.indexOf(b.id)

				return (aOrder < bOrder) ? -1 : (aOrder > bOrder) ? 1 : 0
			})
		}

		return accountsArray
	}

	render() {
		const {
			userData,
			allAccounts,
			accountData,
			closeCallback
		} = this.props

		if(!userData || !userData.accounts){
			return null 
		}

		this.accountsArray = this.getAccountsArray()

		const hasOneAccount = this.accountsArray.length === 1

		return (
			<div>
				<DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
					<Droppable droppableId={'organisations'} type="ORGANISATION">
						{ provided => (
							<ul 
								className="accounts-list users-list list"
								ref={provided.innerRef}
							>
								{ this.accountsArray.map((account, index) => {
										const buttonProps = []
										
										const isAdmin = account.adminIds.indexOf(userData.id) !== -1

										if(account.users.length > 1){
											buttonProps.push({
												icon: 'sign-out',
												callback: _ => {this.doAccountAction('leave', account)},
												label: 'Leave organization',
												tooltip: 'Leave organization'
											})
										}

										if(isAdmin && !hasOneAccount){
											buttonProps.push({
												icon: 'fe-trash-2',
												callback: _ => {this.doAccountAction('delete', account)},
												label: 'Delete organization',
												tooltip: 'Delete organization'
											})
										}

										return (
											<Draggable 
												index={index} 
												key={account.id}
												draggableId={'org-'+account.id} 
												type="ORGANISATION"
											>
												{(provided, snapshot) => {
													const listItem = (
														<div 
															ref={provided.innerRef}
															{...provided.draggableProps} 
															{...provided.dragHandleProps} 
														>
															<li 
																onClick={_ => { this.swapAccount(account.slug) }} 
																className={accountData.id == account.id ? 'list-item active' : 'list-item'} 
																
															>
																<div>
																	<ProfilePicture 
																		account={account} 
																		size="original"
																	/>
																	<div className="user-meta">
																		<h3>
																			{ account.name }
																		</h3>
																		<p>
																			{`${account.users.length} user${account.users.length > 1 ? 's' : ''}` }
																		</p>
																		{ isMobile() ?
																			<MobileSubMenu 
																				options={buttonProps} 
																				isUp={(this.accountsArray.length > 3 && index == (this.accountsArray.length - 1))}
																			/>
																		: 
																			<div 
																				className="button-shelf" 
																				onClick={e => {e.stopPropagation()}}
																			>
																				{ buttonProps.map((button,index) => {
																					return (
																						<div 
																							key={index}
																							className="tooltip-trigger"
																						>
																							<Button 
																								size={'small'} 
																								level={'x-low'} 
																								icon={button.icon} 
																								callback={button.callback}
																							/>
																							<div className="tooltip">
																								{ button.tooltip }
																							</div>
																						</div>																					
																					)
																				})}
																			</div>
																		}
																	</div>
																</div>
															</li>
															{ provided.placeholder }
														</div>
													)

													if(snapshot.isDragging && this.portal){
														return ReactDOM.createPortal(listItem, this.portal)
													}else{
														return listItem
													}
												}}
											</Draggable>
										)
								}) }
								{ provided.placeholder }
							</ul>
						)}
					</Droppable>
				</DragDropContext>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.addNewAccount} 
					label={'Add new'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		allAccounts: state.account.entities.accounts,
		accountData: state.account.accountData
	}
}

export default withRouter(connect(mapStateToProps, { 
	saveItem, 
	openModal,
	updateOrganisationOrder
})(ModalOrganisations))
